<dv-dialog-content>
  <div class="release-notes-dialog">
    <div>
      {{ 'ReleaseDialog.Version' | translate }}:
      <b>{{ data.version | translate }}</b>
    </div>
    <div>
      {{ 'ReleaseDialog.ReleaseDate' | translate }}:
      <b>{{ data.date | translate }}</b>
    </div>
    @if (sanitizedBody(); as releaseNotesHtml) {
      <div
        class="release-notes-dialog__body"
        [innerHTML]="releaseNotesHtml"></div>
    } @else {
      <div class="release-notes-dialog__body--empty">
        {{ 'General.NoReleaseNotesFound' | translate }}
      </div>
    }
    <app-release-notes-link></app-release-notes-link>
  </div>
  <dv-button footer-right color="secondary" (click)="confirm()">
    {{ 'General.Ok' | translate | uppercase }}
  </dv-button>
</dv-dialog-content>
